// src/components/Home.js
import React from 'react';
import CreateProduct from "../components/ProductManagememt/CreateProduct";
import './style.css'

const CreateProductPage = () => {
    return (
        <CreateProduct/>
    )
}

export default CreateProductPage;